import { render, staticRenderFns } from "./pg-button-group.vue?vue&type=template&id=f262247c&scoped=true&"
import script from "./pg-button-group.vue?vue&type=script&lang=js&"
export * from "./pg-button-group.vue?vue&type=script&lang=js&"
import style0 from "./pg-button-group.vue?vue&type=style&index=0&id=f262247c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f262247c",
  null
  
)

export default component.exports